import { render, staticRenderFns } from "./LoginSms2.vue?vue&type=template&id=2abb8d20&scoped=true&"
import script from "./LoginSms2.vue?vue&type=script&lang=js&"
export * from "./LoginSms2.vue?vue&type=script&lang=js&"
import style0 from "./LoginSms2.vue?vue&type=style&index=0&id=2abb8d20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb8d20",
  null
  
)

component.options.__file = "LoginSms2.vue"
export default component.exports